import { render, staticRenderFns } from "./IpoResultFunds.vue?vue&type=template&id=ef496a90&scoped=true"
import script from "./IpoResultFunds.vue?vue&type=script&lang=js"
export * from "./IpoResultFunds.vue?vue&type=script&lang=js"
import style0 from "./IpoResultFunds.vue?vue&type=style&index=0&id=ef496a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef496a90",
  null
  
)

export default component.exports